"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionCount = exports.useStyles = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const Typography_1 = __importDefault(require("@material-ui/core/Typography"));
const makeStyles_1 = __importDefault(require("@material-ui/core/styles/makeStyles"));
const selector_1 = require("../../composite/form/selectors/selector");
const tooltip_1 = require("../tooltip/tooltip");
exports.useStyles = (0, makeStyles_1.default)(() => ({
    label: {
        fontWeight: 600,
    },
}));
function CollectionCount({ source, formKey, items = [], }) {
    const classes = (0, exports.useStyles)();
    const { formItems } = (0, selector_1.useFormSelector)((values) => {
        var _a;
        return ({
            formItems: (_a = values === null || values === void 0 ? void 0 : values[formKey !== null && formKey !== void 0 ? formKey : '']) !== null && _a !== void 0 ? _a : [],
        });
    });
    let label = `[ ${items.length} ]`;
    if (source) {
        label = `[ ${source.items.length} / ${source.count} ]`;
    }
    if (formKey) {
        label = `[ ${formItems.length} ]`;
    }
    return (react_1.default.createElement(tooltip_1.Tooltip, { title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__COLLECTION_COUNT", defaultMessage: "Po\u010Det / Celkov\u00FD po\u010Det z\u00E1znam\u016F" }) },
        react_1.default.createElement(Typography_1.default, { variant: "body1", display: "inline", className: classes.label }, label)));
}
exports.CollectionCount = CollectionCount;
//# sourceMappingURL=collection-count.js.map